  import { Component, EventEmitter, Input, Output, OnInit, ViewChild } from '@angular/core';
import { eColumnType } from '@hub/generated/enums';
import { GridColumnDto } from '@hub/generated/models';
import { IOnLazyLoad } from '@hub/interfaces/IOnLazyLoad';
import { SortMeta, SelectItem } from 'primeng/api';
import { GridStylingDto } from '@hub/models/grids/GridStylingDto';
import { LookUps } from '@hub/common/LookUps';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-grid-wrapper',
  templateUrl: './grid-wrapper.component.html'
})
export class GridWrapperComponent implements OnInit{
  constructor() {
    this.columnTypes = LookUps.getColumnTypesLu();
  }

  // Enumerations
  type = eColumnType;
  columnTypes: SelectItem[] = [];
  sortField: string;
  sortOrder: number;
  first: number;
  @ViewChild(Table) table: Table;
  @Input() ActiveFlag: string;
  @Input() Columns: GridColumnDto[];
  @Input() TotalCount: number;
  @Input() PageSize: number;
  @Input() RowsPerPage: number[];
  @Input() set Sorting(sm: SortMeta[]) {
    // this.table.first = 0;
    if (Array.isArray(sm) && sm.length > 0) {
        this.sortField = sm[0].field;
        this.sortOrder = sm[0].order;
    }
  }
  @Input() FooterText: string;
  @Input() IsEmptyMessage: boolean = true;
  @Input() IsEdit: boolean;
  @Input() First: number = 0;
  @Input() Data: any[] = [];
  @Input() Selection: any[] = [];
  @Input() Styling: GridStylingDto<any>;

  @Output() ColumnsChange: EventEmitter<GridColumnDto[]> = new EventEmitter<GridColumnDto[]>();
  @Output() SelectionChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  @Output() onReorder: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();
  @Output() onLazyLoad: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();

  ngOnInit() {
    this.lazyLoad({sortField: this.sortField, sortOrder: this.sortOrder});
  }

  public reorder(values) {
    const reorderColumns: GridColumnDto[] = new Array<GridColumnDto>();
    let index = 1;
    for (const val of values.columns) {
      const column = this.Columns.find(
        f => f.Header === (val.Header === undefined ? '' : val.Header)
      );
      column.Order = index;
      reorderColumns.push(column);
      index++;
    }

    this.Columns = reorderColumns;

    this.ColumnsChange.emit(this.Columns);
  }

  public rowSelect(event) {
    this.SelectionChange.emit(this.Selection);
  }

  public rowUnselect(event) {
    this.SelectionChange.emit(this.Selection);
  }

  public lazyLoad(event) {
    this.onLazyLoad.emit(event);
  }

  public toggleSelection() {
    this.SelectionChange.emit(this.Selection);
  }

  onPage(event) {
    this.Selection = [];
    this.SelectionChange.emit(this.Selection);
  }
}
